export const LOADER_FORMULARIO_FACTOR          =       'LOADER_FORMULARIO_FACTOR';
export const GET_FORMULARIO_FACTOR             =       'GET_FORMULARIO_FACTOR';
export const FORMULARIO_FACTOR_FALLA           =       'FORMULARIO_FACTOR_FALLA';
export const SAVE_LOADER_FORMULARIO_FACTOR     =       'SAVE_LOADER_FORMULARIO_FACTOR';
export const FORM_FORMULARIO_FACTOR_FAIL       =       'FORM_FORMULARIO_FACTOR_FAIL';
